const FOREGROUND_COLORS = "#887626 #B95E06 #CF0000 #D81CAA #9013FE #0562B9 #118A0F #945216 #666666".split(" ")
const BACKGROUND_COLORS = "#FAF785 #FFF0DB #FFE5E5 #FFE4F7 #F2EDFF #E1EFFC #E4F8E2 #EEE2D7 #F2F2F2".split(" ")
const HUMAN_COLORS = "yellow orange red pink purple blue green #brown gray".split(" ")

function getRGBValues(color) {
    const match = color.match(/rgba?\((\d+),\s*(\d+),\s*(\d+)/i)
    if (match) {
        return Array.from(match).slice(-3).map(Number)
    } else {
        const canvas = document.createElement("canvas")
        canvas.height = canvas.width = 1
        const context = canvas.getContext("2d")
        context.fillStyle = color
        context.fillRect(0, 0, 1, 1)
        const { data } = context.getImageData(0, 0, 1, 1)
        const [ r, g, b ] = data
        return [ r, g, b ].map(Number)
    }
}

function numberToHex(number) {
    return `0${number.toString(16)}`.slice(-2).toUpperCase()
}

function getHexColor(color) {
    if (!color) return ""
    if (/^#/.test(color)) return color

    const rgbValues = getRGBValues(color)
    const hexValues = rgbValues.map(numberToHex)
    return "#" + hexValues.join("")
}

function colorParser(colors) {
    return function(element) {
        while (element && element.tagName !== "TRIX-EDITOR") {
            const color = getHexColor(element.style[this.styleProperty])
            if (colors.includes(color)) {
                return color
            }
            element = element.parentElement
        }
    }
}

class TrixEditorController {
    constructor(element) {
        this.element = element;
    }

    get editorElement() {
        return this.element?.querySelector("trix-editor");
    }

    get editor() {
        return this.editorElement?.editor;
    }

    get trixToolbarElement() {
        return this.editorElement?.toolbarElement
    }

    get foregroundColorTargets() {
        return this.trixToolbarElement?.querySelectorAll("[data-color-picker-target=foregroundColor]")
    }

    get backgroundColorTargets() {
        return this.trixToolbarElement?.querySelectorAll("[data-color-picker-target=backgroundColor]")
    }

    get buttonTarget() {
        return this.element.querySelector("[data-color-picker-target=button]")
    }

    get dialogTarget() {
        return this.element?.querySelector("[data-color-picker-target=dialog]")
    }

    initTrixToolbar() {
        this.addToolbarElements();
        this.toggleRemoveButton(false);
        this.addEventListeners();
    }

    pick(event) {
        const { name, value, checked } = event.target;

        this.applyToolbarChanges("Set color", () => {
            this.updateAttribute(name, checked ? value : false);
        });
    }

    clear() {
        this.applyToolbarChanges("Remove all coloring", () => {
            this.updateAttribute("foregroundColor", false);
            this.updateAttribute("backgroundColor", false);
        });
    }

    dialogShown(event) {
        if (event.dialogName === "color-picker") {
            this.updateToolbarButton(true);
            //this.dialogTarget.querySelector("input").focus();
        }
    }

    attributeChanged(event) {
        const foreground = event.attributes.foregroundColor;
        const background = event.attributes.backgroundColor;
        const selected = this.hasColoredSelection();

        this.updateDialog(foreground, background, selected);
        this.updateToolbarButton(foreground || background || selected);
    }

    applyToolbarChanges(description, fn) {
        this.recordUndoEntry(description);
        fn();
        this.hideDialog();
    }

    recordUndoEntry(description) {
        const selectionIsFrozen = this.editor.attributeIsActive("frozen");

        if (selectionIsFrozen) {
            this.editor.deactivateAttribute("frozen");
        }

        this.editor.recordUndoEntry(description);

        if (selectionIsFrozen) {
            this.editor.activateAttribute("frozen");
        }
    }

    updateAttribute(attribute, value) {
        if (value) {
            this.editor.activateAttribute(attribute, value);
        } else {
            this.editor.deactivateAttribute(attribute);
        }
    }

    updateToolbarButton(allow) {
        this.buttonTarget?.classList?.toggle("trix-active", !!allow);
    }

    toggleRemoveButton(allow) {
        if(this.dialogTarget){
            this.dialogTarget.classList.toggle("color_dialog--selection-contains-coloring", !!allow);
        }
    }

    hideDialog() {
        this.editorElement.editorController.toolbarController.hideDialog();
    }

    updateDialog(foreground, background, selected) {
        this.updateSwatch(this.foregroundColorTargets, foreground);
        this.updateSwatch(this.backgroundColorTargets, background);
        this.toggleRemoveButton(foreground || background || selected);
    }

    updateSwatch(targets, color) {
        targets?.forEach(checkbox => checkbox.checked = checkbox.value === color);
    }

    hasColoredSelection() {
        const range = this.editor.getSelectedRange();
        if (range[0] === range[1]) return false;

        for (let position = range[0]; position <= range[1]; position++) {
            const attributes = this.editor.getDocument().getCommonAttributesAtPosition(position);
            if (attributes.foregroundColor || attributes.backgroundColor) return true;
        }

        return false;
    }

    addToolbarElements() {
        if(this.trixToolbarElement){
            const textTools = this.trixToolbarElement.querySelector(".trix-button-group.trix-button-group--text-tools");
            textTools.insertAdjacentHTML("beforeend", this.colorPickerButton());

            const trixDialogs = this.trixToolbarElement.querySelector("[data-trix-dialogs]");
            trixDialogs.insertAdjacentHTML("beforeend", this.colorPickerDialog());
        }
    }

    activateToolbar() {
        this.trixToolbarElement?.classList?.add('active');
    }

    deactivateToolbar() {
        this.trixToolbarElement?.classList?.remove('active');
    }

    clickOutside(event) {
        if (!this.element.contains(event.target)) {
            this.deactivateToolbar();
        }
    }

    addEventListeners() {
        // toolbar
        this.trixToolbarElement?.querySelector("[data-action='color-picker#clear']").addEventListener("click", this.clear.bind(this));
        this.trixToolbarElement?.querySelectorAll("[data-action='change->color-picker#pick']").forEach(checkbox => checkbox.addEventListener("change", this.pick.bind(this)));

        // Add event listener to activate toolbar
        this.editorElement.addEventListener('click', () => this.activateToolbar());
        this.editorElement.ownerDocument.defaultView.addEventListener('click', (event) =>  this.clickOutside(event));

        // editor
        this.element.addEventListener("trix-attributes-change", (event) => this.attributeChanged(event));
        this.element.addEventListener("trix-toolbar-dialog-show", (event) => this.dialogShown(event));
    }

    colorPickerButton() {
        return `
              <button
                type="button"
                class="trix-button trix-button--icon trix-button--icon-color"
                title="Color"
                tabindex="-1"
                data-trix-action="color-picker"
                data-color-picker-target="button">Color</button>
            `;
    }

    colorPickerDialog() {
        return `
              <div class="trix-dialog trix-dialog--color centered" data-trix-dialog="color-picker" data-color-picker-target="dialog" data-color-picker-target="dialog">
                <div class="color-pickers">
                  <div class="color-picker color-picker--for-text color-picker--for-text-foreground">
                    ${this.foregroundColorPickerSwatches()}
                  </div>
                  <div class="color-picker color-picker--for-text color-picker--for-text-background">
                    ${this.backgroundColorPickerSwatches()}
                  </div>
                  <div class="push--top color_dialog__hide-unless-selection-contains-coloring">
                    <button type="button" class="color-picker-remove-button" data-action="color-picker#clear" data-color-picker-target="button">Cancella formato</button>
                  </div>
                </div>
              </div>
            `;
    }

    foregroundColorPickerSwatches() {
        return this.colorPickerSwatches(FOREGROUND_COLORS, "text", "foregroundColor");
    }

    backgroundColorPickerSwatches() {
        return this.colorPickerSwatches(BACKGROUND_COLORS, "highlight", "backgroundColor");
    }

    colorPickerSwatches(colors, description, target) {
        return colors.map((color, i) => this.colorPickerSwatch(color, HUMAN_COLORS[i], description, target)).join("\n");
    }

    colorPickerSwatch(color, name, description, target) {
        return `
              <label
                class="color-picker__field"
                title="Set ${name} ${description} color">Set ${name} ${description} color
                <input
                  type="checkbox"
                  name="${target}"
                  value="${color}"
                  class="color-picker__input"
                  data-action="change->color-picker#pick"
                  data-color-picker-target="${target}" />
                <span class="color-picker__swatch" style="background-color: ${color}; color: ${color}"></span>
              </label>
            `;
    }
}

function getDefaultHTML(Trix) {
    const {lang} = Trix.config;
    return `<div class="trix-button-row">
                    <span class="trix-button-group trix-button-group--text-tools" data-trix-button-group="text-tools">
                        <button type="button" class="trix-button trix-button--icon trix-button--icon-bold" data-trix-attribute="bold" data-trix-key="b" title="${lang.bold}" tabindex="-1">${lang.bold}</button>
                        <button type="button" class="trix-button trix-button--icon trix-button--icon-italic" data-trix-attribute="italic" data-trix-key="i" title="Italic" tabindex="-1" data-trix-active="">Italic</button>
                        <button type="button" class="trix-button trix-button--icon trix-button--icon-bullet-list" data-trix-attribute="bullet" title="${lang.bullets}" tabindex="-1">${lang.bullets}</button>
                        <button type="button" class="trix-button trix-button--icon trix-button--icon-number-list" data-trix-attribute="number" title="${lang.numbers}" tabindex="-1">${lang.numbers}</button>
                    </span>
                </div>
                <div class="trix-dialogs" data-trix-dialogs="">`
}

export function enableEditing(element, editableSelector) {
    element.querySelectorAll(editableSelector).forEach((el, index) => {
        const content = el.innerHTML.replace(/"/g, "&quot;");

        // iterate though all the tag with data-editable and insert a trix-editor-container with its toolbar,  and input
        el.innerHTML = `
                <span class="editor-container">
                    <input type="hidden" name="editor-input-${index}" id="editor-input-${index}" value="${content}">
                    <trix-toolbar id="toolbar-${index}"></trix-toolbar>
                    <trix-editor input="editor-input-${index}" toolbar="toolbar-${index}"></trix-editor>
                </span>
            `;
    });
}

export function disableEditing(element, editableSelector) {
    // iterate though all the tag with data-editable and replace the trix-editor-container with its value
    element.querySelectorAll(editableSelector).forEach(el => {
        const input = el.querySelector('input');
        el.innerHTML = input.value;
    });
}

export function initTrixControllers (event, Trix, editableSelector) {
    Trix.config.toolbar.getDefaultHTML = getDefaultHTML;

    Trix.config.textAttributes.foregroundColor = {
        inheritable: true,
        styleProperty: "color",
        parser: colorParser(FOREGROUND_COLORS),
    }

    Trix.config.textAttributes.backgroundColor = {
        inheritable: true,
        styleProperty: "backgroundColor",
        parser: colorParser(BACKGROUND_COLORS),
    }

    const editorElement = event.target;
    const editableDataElement = editorElement.closest(editableSelector);

    // Change the default toolbar to hide some button and add the color one
    const toolbarHtml = Trix.config.toolbar.getDefaultHTML(Trix);
    const toolbar = editorElement.toolbarElement;
    toolbar.innerHTML = toolbarHtml;

    // Add the colorPicker controller
    const trixEditorController = new TrixEditorController(editableDataElement);
    trixEditorController.initTrixToolbar();
}